import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/registerSW";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Progressive enhancement: register the PWA service worker after React
// boots. SW registration soft-fails (e.g. http previews, unsupported
// browsers) so this never blocks app startup.
registerServiceWorker();
